<template>
<div class="environmentPage">
	<div class="environmentImageBox" ref="headerImageRef">
		<img class="environmentImage" src="@/assets/environmentIMG.png" />
		<div class="environmentTextBox">
			<div class="environmentTitle" style="margin-top: 3rem;">
				一个AI中枢，四大板块，八大品牌<br />
                One AI Core, 4 Segments, 8 Brands
			</div>
			<div class="environmentText" style="margin-top: 3rem;">
				PULSE生态，用技术串联每一份健康需求<br />
                PULSE Ecosystem: Connecting Every Wellness Need Through Technology
			</div>
		</div>
	</div>

	<div style="height: 11.7rem; width: 1px;" />

    <div>
        <div class="boxCNTitle">
            生态结构展示
        </div>
        <div style="width: 1px; height: 1rem" />

        <div class="boxENTitle">
            ECOLOGICAL STRUCTURE DISPLAY
        </div>

        <div style="height: 6.7rem; width: 1px;" />
        <img src="@/assets/environment_loop.png" class="loopImage" />
    </div>
    <div style="height: 11.7rem; width: 1px;" />

    <div style="width: 1px; height: 6.7rem" />
    <div class="boxCNTitle">
        生态核心优势
    </div>
    <div style="width: 1px; height: 1rem" />

    <div class="boxENTitle">
        ECOLOGICAL CORE ADVANTAGES
    </div>

    <div style="width: 1px; height: 6.7rem" />
    <div class="systemBox">
        <div class="systemItem">
            <div style="width: 1px; height: 3.3rem" />
            <img src="@/assets/environment0.png" class="systemIcon" />
            <div style="width: 1px; height: 2.1rem" />
            <div class="systemTitle">
                专业支持
            </div>
            <div style="width: 1px; height: 0.8rem" />
            <div class="systemSub">
                跨产品用户数据安全共享，实现 “一人一档” 全场景覆盖
            </div>
        </div>
        <div style="flex: 1; height: 1px;" />
        <div class="systemItem">
            <div style="width: 1px; height: 3.3rem" />
            <img src="@/assets/environment1.png" class="systemIcon" />
            <div style="width: 1px; height: 2.1rem" />
            <div class="systemTitle">
                技术同源
            </div>
            <div style="width: 1px; height: 0.8rem" />
            <div class="systemSub">
                统一 AI 中台支撑，保障各产品体验一致性与功能协同性
            </div>
        </div>
        <div style="flex: 1; height: 1px;" />
        <div class="systemItem">
            <div style="width: 1px; height: 3.3rem" />
            <img src="@/assets/environment2.png" class="systemIcon" />
            <div style="width: 1px; height: 2.1rem" />
            <div class="systemTitle">
                资源共享
            </div>
            <div style="width: 1px; height: 0.8rem" />
            <div class="systemSub">
                集中调度专家、课程、医疗资源，提升服务效率与专业性
            </div>
        </div>
        <div style="flex: 1; height: 1px;" />
        <div class="systemItem">
            <div style="width: 1px; height: 3.3rem" />
            <img src="@/assets/environment3.png" class="systemIcon" />
            <div style="width: 1px; height: 2.1rem" />
            <div class="systemTitle">
                快速适配
            </div>
            <div style="width: 1px; height: 0.8rem" />
            <div class="systemSub">
                基于核心技术快速孵化新场景产品，响应市场需求
            </div>
        </div>
    </div>
    <div style="width: 1px; height: 11.7rem" />

</div>
</template>

<script>
export default {
	data() {
		return {
		}
	},
	methods: {

		emitHeroHeight() {
			const height = this.$refs.headerImageRef ? this.$refs.headerImageRef.offsetHeight : 20;
			this.$emit("headerImageRefHeight", height);
		}
	},
	created() {
	},
	mounted() {
		this.emitHeroHeight();
		window.addEventListener("resize", this.emitHeroHeight);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.emitHeroHeight);
	},
	watch: {
	},
}
</script>

<style lang="scss" scoped>
.environmentPage {
    display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	.environmentImageBox {
		width: 100%;
		height: 51.4rem;
		position: relative;
		background-color: #212121;

		.environmentImage {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0px;
			left: 0px;
			object-fit: cover;
		}

		.environmentTextBox {
			position: absolute;
			width: 1200px;
			left: calc((100% - 1200px) / 2);
			top: 20%;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;

			.environmentTitle {
				font-size: 5.3rem;
				text-align: left;
				color: #FFFFFF;
			}
			.environmentText {
				font-size: 1.5rem;
				line-height: 2.5rem;
				text-align: left;
				color: #FFFFFF;
			}
		}
	}

    .loopImage {
        width: 94.8rem;
        height: auto;
    }

    .systemBox {
        box-sizing: border-box;
        width: 100rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: space-between;
        column-gap: 2rem;

        .systemItem {
            width: 23.5rem;
            height: 21.1rem;
            box-shadow: 0px 0.3rem 3.3rem 0px rgba(51, 51, 51, 0.05);
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            box-sizing: border-box;
            padding-left: 1.8%;
            padding-right: 1.8%;

            .systemIcon {
                width: 5rem;
                height: 5rem;
            }
            .systemTitle {
                font-size: 1.7rem;
                line-height: 2.2rem;
                color: #333333;
            }
            .systemSub {
                font-size: 1.3rem;
                line-height: 2.1rem;
                color: #333333;
                opacity: 0.8;
                text-align: center;
            }
            .systemLine {
                font-size: 1.5rem;
                line-height: 2.4rem;
                color: #333333;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                
                .systemTextDeco {
                    width: 1.7rem;
                    height: 1.7rem;
                    margin-right: 1rem;
                    position: relative;
                }
            }
        }
    }
	
}

.boxCNTitle{
	font-size: 4rem;
	line-height: 4.8rem;
	color: #1D1D1F;
	font-weight: 600;
}
.boxENTitle{
	font-size: 1.7rem;
	line-height: 1.8rem;
	color: #666666;
}
</style>